import { api } from "@/shared/libs/axiosClient";

export interface DutyEntry {
  date: string;
  member_ids: number[];
  is_override: boolean;
}

export interface DutyResponse {
  team_id: number;
  entries: DutyEntry[];
}

export async function fetchOncallDuty(
  teamId: number,
  startsAt: string,
  endsAt: string
): Promise<DutyResponse> {
  return api.get<DutyResponse>(`/teams/${teamId}/oncall_duty`, {
    params: { starts_at: startsAt, ends_at: endsAt },
  });
}
